module.exports = __webpack_public_path__ + "static/media/client.4b311287.svg";